import { useSetPrototypeAppsOptInMutation } from '../../services';
import { useGetUserId } from '../useCredentials';

export const usePrototypeAppsOptIn = () => {
  const userId = useGetUserId();
  const [setPrototypeAppsOptInMutation, { isLoading, error }] =
    useSetPrototypeAppsOptInMutation();

  const setPrototypeAppsOptIn = async () =>
    setPrototypeAppsOptInMutation({ userId }).unwrap();

  return {
    setPrototypeAppsOptIn,
    isLoading,
    error,
  };
};
